import { render, staticRenderFns } from "./FullTextReviewProgressAndResults.vue?vue&type=template&id=731b8098&scoped=true&"
import script from "./FullTextReviewProgressAndResults.vue?vue&type=script&lang=js&"
export * from "./FullTextReviewProgressAndResults.vue?vue&type=script&lang=js&"
import style0 from "./FullTextReviewProgressAndResults.vue?vue&type=style&index=0&id=731b8098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731b8098",
  null
  
)

export default component.exports